<template>
  <div>
    <download-excel
      style=""
      :fetch="startDownload"
      :fields="json_fields"
      type="xls"
      name="砍价订单图表.xls"
    >
      <a-button type="primary" :style="{ margin: '0 0 24px 0' }"
        >导出Excel</a-button
      >
    </download-excel>
    <!-- <a-button type="primary" :style="{ margin: '0 0 24px 0' }">
      Excel导出
    </a-button> -->
    <a-table
      :scroll="{ x: 2000, y: 500 }"
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="data"
      :pagination="pagination"
      :loading="loading"
      @change="handleTableChange"
    >
      <!-- 头像 -->
      <template slot="pic" slot-scope="text">
        <img class="img1" :src="text" alt="" />
      </template>
      <!-- 商品图片 -->
      <template slot="pic2" slot-scope="text">
        <img class="img2" :src="text" alt="" />
      </template>
      <!-- 砍价时长 -->
      <template slot="cutTimeLong" slot-scope="text">
        <span>{{ text }}分钟</span>
      </template>
      <a-avatar slot="avatar" icon="user" />
      <a-switch slot="memberStatus" default-checked @change="onChange" />
      <template slot="operate" slot-scope="text, operate">
        <a href="javascript:;" @click="getMembers(operate)">砍价成员</a>
        <a
          href=""
          v-on:click.prevent="
            topage(
              `/home/bargainingOrderTwo/bargainingOrderDetailsTwo?orderNo=${operate.orderNo}`
            )
          "
          >订单详情</a
        >
      </template>
    </a-table>
    <a-modal v-model="visible" centered width="1000px" title="砍价成员">
      <a-table
        :columns="columnstwo"
        :row-key="(record) => record.userid"
        :data-source="datatwo"
        :pagination="pagination"
        :loading="loading"
      >
        <template slot="pic3" slot-scope="text">
          <img class="img2" :src="text" alt="" />
        </template>
      </a-table>
    </a-modal>
  </div>
</template>
<script>
import {
  bargainingOrderList,
  bargainingOrderListMmber,
  bargainingOrderListSeach,
} from "@/api/storeApi.js";

const columns = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    sorter: true,
    align: "center",
    width: 150,
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "商品名称",
    dataIndex: "goodsName",
    width: 150,
    align: "center",
    scopedSlots: { customRender: "goodsName" },
  },
  {
    title: "商品图片",
    dataIndex: "goodsImg",
    width: 150,
    align: "center",
    scopedSlots: { customRender: "pic2" },
  },
  {
    title: "砍价状态",
    dataIndex: "cutStatus",
    sorter: true,
    align: "center",
    width: 150,
    scopedSlots: { customRender: "cutStatus" },
  },
  {
    title: "用户头像",
    dataIndex: "userHeadImg",
    sorter: true,
    align: "center",
    width: 150,
    scopedSlots: { customRender: "pic" },
  },
  {
    title: "用户uid",
    dataIndex: "userUid",
    sorter: true,
    align: "center",
    width: 150,
    scopedSlots: { customRender: "userUid" },
  },
  {
    title: "砍价时长",
    dataIndex: "cutTimeLong",
    sorter: true,
    width: 150,
    align: "center",
    scopedSlots: { customRender: "cutTimeLong" },
  },
  {
    title: "商品可砍价金额",
    dataIndex: "cutMoney",
    sorter: true,
    width: 150,
    align: "center",
    scopedSlots: { customRender: "cutMoney" },
  },
  {
    title: "砍价人数",
    dataIndex: "cutPeoples",
    sorter: true,
    width: 150,
    align: "center",
    scopedSlots: { customRender: "cutPeoples" },
  },
  {
    title: "相差人数",
    dataIndex: "cutRemaining",
    sorter: true,
    width: 150,
    align: "center",
    scopedSlots: { customRender: "cutRemaining" },
  },
  {
    title: "订单状态",
    dataIndex: "cutStatusStr",
    sorter: true,
    width: 150,
    align: "center",
    scopedSlots: { customRender: "cutStatusStr" },
  },
  {
    title: "砍价成功时间",
    // dataIndex: "endTime",
    sorter: true,
    width: 200,
    align: "center",
    scopedSlots: { customRender: "endTime" },
  },
  {
    title: "砍价结束时间",
    dataIndex: "endTime",
    sorter: true,
    width: 200,
    align: "center",
    scopedSlots: { customRender: "endTime" },
  },
  {
    title: "下单时间",
    dataIndex: "createTime",
    sorter: true,
    width: 200,
    align: "center",
    scopedSlots: { customRender: "createTime" },
  },
  {
    title: "操作",
    dataIndex: "operate",
    sorter: true,
    width: 250,
    fixed: "right",
    scopedSlots: { customRender: "operate" },
  },
];

const columnstwo = [
  {
    title: "订单编号",
    dataIndex: "orderNo",
    sorter: true,
    align: "center",
    width: 120,
    scopedSlots: { customRender: "orderNo" },
  },
  {
    title: "用户id",
    dataIndex: "userUid",
    sorter: true,
    align: "center",
    width: 120,
    scopedSlots: { customRender: "userUid" },
  },
  {
    title: "用户头像",
    dataIndex: "userHeadImg",
    sorter: true,
    align: "center",
    ellipsis: true,
    width: 120,
    scopedSlots: { customRender: "pic3" },
  },
  {
    title: "用户手机号码",
    dataIndex: "phone",
    sorter: true,
    align: "center",
    width: 140,
    scopedSlots: { customRender: "phone" },
  },
  {
    title: "砍价金额",
    dataIndex: "cutMoney",
    sorter: true,
    align: "center",
    width: 120,
    scopedSlots: { customRender: "cutMoney" },
  },
  {
    title: "砍价时间",
    dataIndex: "createTime",
    sorter: true,
    align: "center",
    width: 150,
    scopedSlots: { customRender: "createTime" },
  },
];

export default {
  data() {
    return {
      data: [],
      data1: [],
      datatwo: [],
      json_fields: {
        订单编号: "orderNo",
        商品名称: "goodsName",
        商品图片: (value) => {
          return value;
        },
        砍价状态: "cutStatus",
        用户头像: "userHeadImg",
        用户id: "userUid",
        砍价时长: "cutTimeLong",
        商品可砍价金额: "cutMoney",
        砍价人数: "cutPeoples",
        相差人数: "cutRemaining",
        订单状态: "cutStatusStr",
        砍价成功时间: "createTime",
        砍价结束时间: "endTime",
        下单时间: "createTime",
      },
      pagination: {
        current: 1,
        total: 0,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "40", "80", "100"],
        showTotal: (total) => `共 ${total} 条`,
        pageSize: 10,
      },
      loading: false,
      columns,
      columnstwo,
      visible: false,
    };
  },
  props: ["formInline"],
  mounted() {
    this.getOrderListData();
    this.$bus.$on("Order", () => {
      return this.Order();
    });
  },
  methods: {
    async startDownload(){
      this.loading = true;
      await bargainingOrderListSeach(
        10000,
        1,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.endTime,
        this.formInline.createTime
      ).then((res) => {
        this.data1 = res.data;
        this.loading = false;
      });
      return this.data1;
    },
    topage(routerpath) {
      this.$router.push(routerpath);
    },
    onChange(checked) {
      console.log(`a-switch to ${checked}`);
    },
    //  砍价成员
    getMembers(row) {
      console.log(row.cutNo);
      bargainingOrderListMmber(10, 1, row.cutNo).then((result) => {
        console.log(result);
        this.datatwo = result.data;
      });
      this.visible = true;
    },
    // 获取订单列表
    getOrderListData() {
      bargainingOrderList(10, 1).then((res) => {
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    query() {
      this.loading = true;
      this.pagination.current = 1;
      bargainingOrderListSeach(
        this.formInline.limit,
        1,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.endTime,
        this.formInline.createTime
      ).then((res) => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
    },
    // 分页数据
    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      this.loading = true;
      this.pagination.current = pagination.current; //重置当前页
      // bargainingOrderList(10, this.pagination.current).then((res) => {
      //   this.data = res.data;
      //   console.log(res);
      // });
      bargainingOrderListSeach(
        this.formInline.limit,
        this.pagination.current,
        this.formInline.userUid,
        this.formInline.orderNo,
        this.formInline.endTime,
        this.formInline.createTime
      ).then((res) => {
        this.loading = false;
        this.pagination.total = res.count;
        this.data = res.data;
      });
      this.loading = false;
    },
  },
  showModal() {
    this.visible = true;
  },
};
</script>
<style scoped>
.img1 {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}
.img2 {
  width: 100px;
  height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/views/orderManagement/bargainingOrderTwo/bargainingOrderContentTwo.vue